export default __webpack_public_path__ + "static/media/slide1.2c0c1ef4.jpg";